module.exports = __webpack_public_path__ + "images/illustrations/illustration-soccer@1x-1639163e044f5a906c7a17262b127a02.webp";